module.exports = __webpack_public_path__ + "img/LATIN10_06.693b2b15.jpg";